<template>
  <el-menu
      :default-active="path"
      @select="handleSelect"
      class="el-menu-vertical-demo">
    <el-menu-item index="/user/course">
      <i class="el-icon-notebook-1"></i>
      <span slot="title">我的课程</span>
    </el-menu-item>
    <el-menu-item index="/user/order">
      <i class="el-icon-s-order"></i>
      <span slot="title">我的订单</span>
    </el-menu-item>
    <el-menu-item index="/user/problem">
      <i class="el-icon-document"></i>
      <span slot="title">我的答疑</span>
    </el-menu-item>
    <el-menu-item index="/user/ask">
      <i class="el-icon-question"></i>
      <span slot="title">我的提问</span>
    </el-menu-item>
    <el-menu-item index="/user/wrong">
      <i class="el-icon-s-release"></i>
      <span slot="title">我的错题</span>
    </el-menu-item>
    <el-menu-item index="/user">
      <i class="el-icon-user"></i>
      <span slot="title">个人信息</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "TheLeft",
  data() {
    return {
      path: ''
    }
  },
  created() {
    this.path = this.$route.path
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({path: key})
    },
  }
}
</script>

<style scoped>
</style>